module.exports = __webpack_public_path__ + "img/高精度海洋叶绿素反演系统.03cb9b05.png";